module.exports = __webpack_public_path__ + "img/league_new_prev.c8ce507c.svg";